// Request to ask for search term suggestions for a given input
export const SearchService_GetSuggestionsLazy = () =>
  import("./service.grpc").then((m) => m.SearchService_GetSuggestions);
SearchService_GetSuggestionsLazy.method =
  "aysa_api.services.search.v1.SearchService/GetSuggestions" as const;

// Returns data for the BAS banner
export const SearchService_GetBasBannerLazy = () =>
  import("./service.grpc").then((m) => m.SearchService_GetBasBanner);
SearchService_GetBasBannerLazy.method =
  "aysa_api.services.search.v1.SearchService/GetBasBanner" as const;

// Request to ask for empty search page elements for given target group
export const SearchService_GetEmptySearchRecommendationsLazy = () =>
  import("./service.grpc").then(
    (m) => m.SearchService_GetEmptySearchRecommendations
  );
SearchService_GetEmptySearchRecommendationsLazy.method =
  "aysa_api.services.search.v1.SearchService/GetEmptySearchRecommendations" as const;

// Request to ask for empty search page elements for given target group
// Deprecated, please use GetEmptySearchPage instead
export const SearchService_GetEmptySearchCategoriesLazy = () =>
  import("./service.grpc").then(
    (m) => m.SearchService_GetEmptySearchCategories
  );
SearchService_GetEmptySearchCategoriesLazy.method =
  "aysa_api.services.search.v1.SearchService/GetEmptySearchCategories" as const;

// Returns all sections for the Empty search page
export const SearchService_GetEmptySearchPageLazy = () =>
  import("./service.grpc").then((m) => m.SearchService_GetEmptySearchPage);
SearchService_GetEmptySearchPageLazy.method =
  "aysa_api.services.search.v1.SearchService/GetEmptySearchPage" as const;

// Returns a list of productIds that match the searched term
export const SearchService_GetProductSearchResultsLazy = () =>
  import("./service.grpc").then((m) => m.SearchService_GetProductSearchResults);
SearchService_GetProductSearchResultsLazy.method =
  "aysa_api.services.search.v1.SearchService/GetProductSearchResults" as const;

// Request to resolve a search term to a URL
export const SearchService_GetResolvedTermLazy = () =>
  import("./service.grpc").then((m) => m.SearchService_GetResolvedTerm);
SearchService_GetResolvedTermLazy.method =
  "aysa_api.services.search.v1.SearchService/GetResolvedTerm" as const;

// returns a bulk response for the search results page
export const SearchService_GetSearchResultsPageBulkLazy = () =>
  import("./service.grpc").then(
    (m) => m.SearchService_GetSearchResultsPageBulk
  );
SearchService_GetSearchResultsPageBulkLazy.method =
  "aysa_api.services.search.v1.SearchService/GetSearchResultsPageBulk" as const;

// endpoint for resolving elements for the search results page
export const SearchService_GetSearchResultsStreamLazy = () =>
  import("./service.grpc").then((m) => m.SearchService_GetSearchResultsStream);
SearchService_GetSearchResultsStreamLazy.method =
  "aysa_api.services.search.v1.SearchService/GetSearchResultsStream" as const;
